import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router';
import { sfyr } from '@epilogo/core/src/_ctx/sfyr';

export const LocaleLayout = () => {
  const { lang } = useParams<{ lang: string }>();
  const locale = lang === 'it' ? 'it' : 'en';

  useEffect(() => {
    sfyr.context.update(() => ({ lang: locale }));
  }, [locale]);

  return <Outlet />;
};
